module.exports = __webpack_public_path__ + "img/deals.fa6353bc.svg";